import React, { useState } from 'react';
import * as S from './styles';
import card1 from '../../../front-novo/about/card1.jpg';
// import azul from '../../../front-novo/home/eventos/azul.jpg';
// import azul2 from '../../../front-novo/home/eventos/azul2.jpg';
// import marrom from '../../../front-novo/home/eventos/marrom.jpg';
// import vermelho from '../../../front-novo/home/eventos/vermelho.jpg';
// import more from '../../../front-novo/home/eventos/more.png';
import previous from '../../../front-novo/home/previous.png';
import next from '../../../front-novo/home/next.png';

const items = [
  {
    id: 1,
    title: 'Escutar o texto',
    description: 'Discussão de casos clínicos publicados',
    date: '03/07/2024',
    image: card1,
    cardTheme: 'azul',
  },
];

function Carrossel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex(prevIndex =>
      prevIndex === 0 ? items.length - 1 : prevIndex - 1,
    );
  };

  const handleNext = () => {
    setCurrentIndex(prevIndex =>
      prevIndex >= items.length - 2 ? 0 : prevIndex + 2,
    );
  };

  const handleClick = (id: any) => {
    // Função que será chamada quando o botão for clicado
  };
  return (
    <S.CarrosselContainer>
      <S.CarrosselInner
        style={{ transform: `translateX(-${currentIndex * 101.5}%)` }}
      >
        {items.map(item => (
          <S.CarrosselItem key={item.id}>
            <img src={item.image} alt={item.title} />
          </S.CarrosselItem>
        ))}
      </S.CarrosselInner>
      <S.CarrosselButtons>
        <S.CarrosselButton onClick={handlePrev}>
          {' '}
          <img src={previous} alt="moreButton" />
        </S.CarrosselButton>
        <S.CarrosselButton onClick={handleNext}>
          {' '}
          <img src={next} alt="moreButton" />
        </S.CarrosselButton>
      </S.CarrosselButtons>
    </S.CarrosselContainer>
  );
}

export default Carrossel;
